// Staff headcount input used at checkout; the price band is derived from the number.
export const bandForStaff = (n, bands) => {
  const v = Number(n);
  if (!v || v < 1 || !bands) return null;
  return bands.find((b) => v >= b.staff_min && (b.staff_max == null || v <= b.staff_max)) || null;
};

export const StaffCountInput = ({ value, onChange, band, testid = 'staff-count', className = '' }) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <input type="number" min="1" inputMode="numeric" value={value} placeholder="e.g. 4" data-testid={`${testid}-input`}
      onChange={(e) => onChange(e.target.value.replace(/[^0-9]/g, '').slice(0, 6))}
      className="w-32 border border-[#E5E7EB] rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-[#00A79D]" />
    {band ? (
      <span className="text-sm text-gray-700" data-testid={`${testid}-band`}>
        <b>{band.label}</b> · {band.staff_label} staff · {band.call_only || band.monthly == null ? 'tailored package, book a meeting with Sales' : `£${band.monthly}/mo`}
      </span>
    ) : <span className="text-xs text-gray-500">Include everyone on payroll, full and part time.</span>}
  </div>
);
